import { FiscalDataEmployerRegistrationsErrorBoundary } from '@/pages/fiscal-data/employer-registrations/employer-registrations.error';

export default FiscalDataEmployerRegistrationsErrorBoundary;
